<template>
  <div>
    <ActitiveTabcomponent :tabs="tabItems" :defaultTab="activeTab" @tab-changed="handleTabChange">
      <template v-slot:tab-buttons>
        <div v-if="activeTab === 'AmcList'">
          <v-btn
            @click="toggleShowAddAmcList"
            :color="$vuetify.theme.currentTheme.primary"
            class="normal-case white--text"
          >
            <v-icon left dark>mdi-plus</v-icon>
            Add
          </v-btn>
        </div>
        <div v-else-if="activeTab === 'AmcPlans'" class="flex justify-between">
          <v-text-field
            v-model="searchPlan"
            label="Plans"
            solo
            flat
            clearable
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
            hide-details
            class="filter-column"
          ></v-text-field>
          <v-btn
            @click="toggleShowAddAmcPlan()"
            :color="$vuetify.theme.currentTheme.primary"
            class="normal-case ml-2 white--text"
          >
            <v-icon left dark>mdi-plus</v-icon>
            Add
          </v-btn>
        </div>
      </template>
      <template v-for="tab in visibleTabItems" v-slot:[tab.key]="">
        <div v-if="!isLoad">
          <v-main style="padding: 0px">
            <component
              :is="tab.component"
              @navToAmcPlan="handlePlanTab"
              :search="activeTab === 'AmcPlans' ? searchPlan : ''"
              @edit-item="handleEditItem"
              @delete-item="handleDeleteItem"
            ></component>
          </v-main>
        </div>
        <div v-else class="absolute w-full h-screen flex-col items-center flex justify-center">
          <v-progress-circular
            :color="$vuetify.theme.currentTheme.primary"
            indeterminate
            :size="50"
            :width="5"
          ></v-progress-circular>
          <div class="mt-2"><span>Please Wait...</span></div>
        </div>
      </template>
    </ActitiveTabcomponent>
    <v-dialog v-model="showAddAmcList" width="70rem" persistent>
      <AddAmcList @cancel="toggleShowAddAmcList" @saved="handleAmcSaved" />
    </v-dialog>
    <v-dialog v-model="showAddAmcPlan" width="70rem" persistent>
      <AddAmcPlan
        @cancel="toggleShowAddAmcPlan"
        @saved="handleAmcPlanSaved"
        :editedItem="editedItem"
      />
    </v-dialog>
  </div>
</template>

<script>
// import Overview from "~/components/Workforce/WarrantyManagement/Overview.vue";
import AmcList from '@/components/Workforce/WarrantyManagement/AmcList.vue'
import AmcPlans from '@/components/Workforce/WarrantyManagement/AmcPlans.vue'
import AddAmcPlan from '@/components/Workforce/WarrantyManagement/AddAmcPlan.vue'
import AddAmcList from '@/components/Workforce/WarrantyManagement/AddAmcList.vue'
import { isModuleFeatureAllowed, hasPermission } from '@/utils/common'
import permissionData from '@/utils/permissions'
import ActitiveTabcomponent from '@/components/ActitiveTabcomponent.vue'

export default {
  name: 'WarrantyManagement',
  layout: 'Workforce/default',
  components: {
    // Overview,
    AmcList,
    AddAmcList,
    AddAmcPlan,
    AmcPlans,
    ActitiveTabcomponent
  },
  data() {
    return {
      userData: this.$store.state.wfmPermissions,
      isLoad: true,
      showAddAmcList: false,
      showAddAmcPlan: false,
      searchPlan: '',
      editedItem: null
    }
  },
  computed: {
    canRead() {
      return hasPermission(this.userData, permissionData.amcRead)
    },
    tabItems() {
      return [
        // { key: "Overview", name: "Overview", component: "Overview", visible: this.canRead && this.isFeatureVisible("MANAGE_AMC_OVERVIEW") },
        {
          key: 'AmcList',
          label: 'AMC List',
          icon: 'mdi-format-list-bulleted',
          component: 'AmcList',
          visible: this.canRead && this.isFeatureVisible('MANAGE_AMC_SELLS')
        },
        {
          key: 'AmcPlans',
          label: 'AMC Plans',
          icon: 'mdi-calendar-check',
          component: 'AmcPlans',
          visible: this.canRead && this.isFeatureVisible('MANAGE_AMC_PLANS')
        }
      ]
    },
    visibleTabItems() {
      return this.tabItems.filter((tab) => tab.visible)
    },
    activeTab() {
      return this.$route.query.activeTab || this.defaultTabKey
    },
    defaultTabKey() {
      return this.visibleTabItems.length > 0 ? this.visibleTabItems[0].key : 'AmcList'
    }
  },
  mounted() {
    if (!this.$route.query.activeTab && this.defaultTabKey) {
      this.$router.replace({
        query: { ...this.$route.query, activeTab: this.defaultTabKey }
      })
    }

    this.$nextTick(() => {
      this.isLoad = false
    })
  },
  methods: {
    toggleShowAddAmcList() {
      this.showAddAmcList = !this.showAddAmcList
    },
    toggleShowAddAmcPlan() {
      this.showAddAmcPlan = !this.showAddAmcPlan
      // Reset editedItem when creating a new plan
      if (!this.showAddAmcPlan) {
        this.editedItem = null
      }
    },
    handleAmcSaved() {
      // Close the dialog
      this.showAddAmcList = false
      this.$toast.success('AMC List added successfully')
    },
    handleAmcPlanSaved() {
      // Close the dialog first
      this.showAddAmcPlan = false
      this.editedItem = null
      this.$toast.success('AMC Plan saved successfully')
      this.$root.$emit('refresh-amc-plans')
    },
    handleEditItem(item) {
      this.editedItem = item
      this.showAddAmcPlan = true
    },
    handleDeleteItem(item) {
      this.showAddAmcPlan = false
      this.$toast.success('AMC Plan deleted successfully')
    },
    handleTabChange(tabKey) {
      if (this.$route.query.activeTab !== tabKey) {
        this.$router.replace({
          query: { ...this.$route.query, activeTab: tabKey }
        })
      }
    },
    handlePlanTab() {
      const planTabKey = 'AmcPlans'
      this.handleTabChange(planTabKey)
    },
    isFeatureVisible(feature) {
      return isModuleFeatureAllowed('AMC', feature)
    }
  }
}
</script>

<style scoped>
.v-tab:before {
  background-color: transparent;
}

.v-tab {
  font-size: var(--font-subheading-sm);
}

.filter-column {
  width: 300px;
}
</style>
